/* CAMPAIGN_RESULTS_v1 */
import { useEffect, useState } from 'react';
import client from '../api/client';
import { useNavigate } from 'react-router-dom'; /* CAMPAIGN_ROUTE_v2 */

const card = { background:'#fff', border:'1px solid #e5e7eb', borderRadius:12, padding:20, marginBottom:16 };
const lbl = { fontSize:12, color:'#6b7280', display:'block', marginBottom:4 };
const th = { fontSize:11, color:'#6b7280', textTransform:'uppercase', letterSpacing:'.03em' };
const chipBase = { padding:'4px 11px', borderRadius:8, border:'1px solid #d1d5db', fontSize:12, cursor:'pointer', background:'#fff', color:'#374151' };
const chipOn = { ...chipBase, background:'#dbeafe', border:'1px solid #2563eb', color:'#1e40af', fontWeight:600 };
const warn = { background:'#fef9c3', border:'1px solid #fde047', borderRadius:8, padding:'8px 12px', fontSize:12, color:'#854d0e', marginBottom:14 };

const n = v => Number(v || 0);
const fmt = v => n(v).toLocaleString();
const pct = (a,b) => n(b) ? Math.round(n(a)*100/n(b)) + '%' : '0%';
const dt = s => s ? new Date(s).toLocaleString(undefined,{month:'short',day:'numeric',hour:'2-digit',minute:'2-digit'}) : '';

function Tile({ value, label, danger }) {
  return (
    <div style={{ flex:1, minWidth:92, border:'1px solid #e5e7eb', borderRadius:10, padding:'10px 12px', background: danger ? '#fee2e2' : '#fff' }}>
      <div style={{ fontSize:18, color: danger ? '#991b1b' : '#111' }}>{value}</div>
      <div style={{ fontSize:11, color: danger ? '#991b1b' : '#6b7280' }}>{label}</div>
    </div>
  );
}

function trail(r) {
  const t = [];
  if (r.sent_at) t.push('Sent ✓');
  if (r.delivered_at) t.push('Delivered ✓');
  if (r.opened_at) t.push('Opened ✓');
  if (r.activated_at) t.push('Engaged ✓');
  if (r.status === 'BOUNCED') t.push(r.error ? String(r.error).slice(0,40) : 'Bounced');
  return t.join(' · ');
}

export default function CampaignResults() {
  const nav = useNavigate();
  const [msg, setMsg] = useState('');
  const [rows, setRows] = useState([]);
  const [nudges, setNudges] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const d = await client.get('/admin/marketing/campaigns/results');
        setRows(Array.isArray(d.data.campaigns) ? d.data.campaigns : []);
        const nu = d.data.nudges;
        setNudges(Array.isArray(nu) ? (nu[0] || null) : (nu || null));
      } catch (e) { setMsg('Failed to load campaigns'); }
    })();
  }, []);


  const pick = (c) => nav('/campaign/' + c.id);

  /* CAMPAIGN_DEL_UI_v1 */
  const del = async (e, c) => {
    e.stopPropagation();
    if (!window.confirm('Delete draft campaign "' + c.name + '"? This cannot be undone.')) return;
    try {
      await client.delete('/admin/marketing/campaigns/' + c.id);
      setRows(rows.filter(r => r.id !== c.id));
      setMsg('Deleted "' + c.name + '"');
    } catch (err) {
      const body = err.response && err.response.data ? err.response.data : err.message;
      setMsg('Could not delete: ' + body);
    }
  };

  const bouncePct = c => n(c.sent) ? n(c.bounced)*100/n(c.sent) : 0;

  return (
    <div style={{ maxWidth:1100, margin:'0 auto', padding:'20px 16px' }}>
      <h2 style={{ margin:'0 0 2px', fontSize:20 }}>Campaigns</h2>
      <div style={{ fontSize:12, color:'#6b7280', marginBottom:14 }}>
        {rows.length} campaigns · mail-scanner fetches are excluded from Engaged
      </div>
      {msg && <div style={warn}>{msg}</div>}

      <div style={{ ...card, padding:0, overflow:'hidden' }}>
        <div style={{ display:'flex', padding:'8px 14px', borderBottom:'1px solid #e5e7eb' }}>
          <div style={{ width:34, ...th }}>#</div>
          <div style={{ flex:1, ...th }}>Campaign</div>
          <div style={{ width:60, textAlign:'right', ...th }}>Sent</div>
          <div style={{ width:78, textAlign:'right', ...th }}>Bounced</div>
          <div style={{ width:64, textAlign:'right', ...th }}>Opened</div>
          <div style={{ width:70, textAlign:'right', ...th }}>Engaged</div>
          <div style={{ width:64, textAlign:'right', ...th }}>Signed</div>
          <div style={{ width:30 }} />
        </div>
        {rows.map((c, i) => (
          <div key={c.id} onClick={() => pick(c)} style={{ display:'flex', alignItems:'center', padding:'10px 14px', borderBottom:'1px solid #f3f4f6', cursor:'pointer', background: '#fff', borderLeft: '3px solid transparent' }}>
            <div style={{ width:34, fontSize:12, color:'#9ca3af' }}>{i + 1}</div>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ fontSize:13, color:'#2563eb' }}>{c.name}</div>
              <div style={{ fontSize:11, color:'#6b7280' }}>{dt(c.sent_at)} · {c.segment || c.status}</div>
            </div>
            <div style={{ width:60, textAlign:'right', fontSize:13 }}>{fmt(c.sent)}</div>
            <div style={{ width:78, textAlign:'right', fontSize:13, color: bouncePct(c) > 4 ? '#dc2626' : '#111' }}>{fmt(c.bounced)} · {pct(c.bounced, c.sent)}</div>
            <div style={{ width:64, textAlign:'right', fontSize:13 }}>{fmt(c.opened)}</div>
            <div style={{ width:70, textAlign:'right', fontSize:13, color: n(c.engaged) ? '#166534' : '#111' }}>{fmt(c.engaged)}</div>
            <div style={{ width:64, textAlign:'right', fontSize:13, color: n(c.signed_up) ? '#166534' : '#111' }}>{fmt(c.signed_up)}</div>
            <div style={{ width:30, textAlign:'right' }}>
              {c.status === 'DRAFT' && (
                <span title="Delete draft" onClick={(e) => del(e, c)} style={{ cursor:'pointer', color:'#dc2626', fontSize:14 }}>&#128465;</span>
              )}
            </div>
          </div>
        ))}
        {nudges && (
          <div style={{ display:'flex', alignItems:'center', padding:'10px 14px', background:'#f8fafc', borderLeft:'3px solid transparent' }}>
            <div style={{ width:34, fontSize:12, color:'#9ca3af' }}>—</div>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ fontSize:13, color:'#111' }}>All nudges</div>
              <div style={{ fontSize:11, color:'#6b7280' }}>{fmt(nudges.campaigns)} campaigns · {dt(nudges.first_sent)} – {dt(nudges.last_sent)}</div>
            </div>
            <div style={{ width:60, textAlign:'right', fontSize:13 }}>{fmt(nudges.sent)}</div>
            <div style={{ width:78, textAlign:'right', fontSize:13 }}>{fmt(nudges.bounced)} · {pct(nudges.bounced, nudges.sent)}</div>
            <div style={{ width:64, textAlign:'right', fontSize:13 }}>{fmt(nudges.opened)}</div>
            <div style={{ width:70, textAlign:'right', fontSize:13, color: n(nudges.engaged) ? '#166534' : '#111' }}>{fmt(nudges.engaged)}</div>
            <div style={{ width:64, textAlign:'right', fontSize:13, color: n(nudges.signed_up) ? '#166534' : '#111' }}>{fmt(nudges.signed_up)}</div>
          </div>
        )}
      </div>

    </div>
  );
}
